export interface HeroSectionProps {
  title: string;
  subtitle: string;
  ctaText: string;
  ctaHref: string;
  secondaryCtaText: string;
  secondaryCtaHref: string;
  backgroundImage: string;
}

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20farm%20field%20with%20rows%20of%20ripening%20watermelons%20and%20melons%20under%20warm%20golden%20sunset%20light%2C%20distant%20green%20hills%2C%20artistic%20warm%20atmospheric%20landscape%20painting%20style%2C%20soft%20dreamy%20golden%20and%20green%20tones%2C%20high%20quality%20wallpaper&width=1800&height=800&seq=hero-bg-main&orientation=landscape"
          alt="瓜瓜基地 - 正宗瓜果产地直采"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 md:mb-6 leading-tight">
            正宗瓜果直采
            <br />
            <span className="text-primary-300">新鲜到家</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/85 max-w-xl mx-auto mb-8 md:mb-10 leading-relaxed">
            从产地到餐桌，严选西瓜、哈密瓜、香瓜等各类时令瓜果，产地直发、品质保障、极速配送，让甜蜜一步到位。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="/category"
              className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              立即选购
            </a>
            <a
              href="/about"
              className="w-full sm:w-auto px-8 py-3 rounded-full border-2 border-background-50/60 text-background-50 text-base font-medium hover:bg-background-50/15 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解我们
            </a>
          </div>
          <div className="flex items-center justify-center gap-6 md:gap-10 mt-10 md:mt-12">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">50万+</p>
              <p className="text-xs md:text-sm text-background-50/70 mt-1">信赖会员</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">20+</p>
              <p className="text-xs md:text-sm text-background-50/70 mt-1">直采产区</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">99.7%</p>
              <p className="text-xs md:text-sm text-background-50/70 mt-1">好评率</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}